
  import { Component, Vue } from 'vue-property-decorator';

  @Component
  export default class PartnerConfirmRegister extends Vue {
    data() {
      return {
        studio: '',
        disableButton: false,
        isButtonLoading: false
      }
    };

    created() {
      this.$data.studio = this.$data.RCEnvironment.VUE_APP_PARTNER_NAME;
    }

    resendSSOEmail() {
      if (this.$data.disableButton) {
        return;
      }

      this.$data.isButtonLoading = true;
      const url = this.$data.RCEnvironment.VUE_APP_IS_PROD == true ?
        "https://sso.reliclink.com/community/sso/resendSSOEmailValidation?title=ANVIL" :
        "https://test-sso.reliclink.com/community/sso/resendSSOEmailValidation?title=ANVIL";
      const headers = { 'Content-Type': 'text/plain' };

      this.$http.post(url, {}, { headers, withCredentials: true })
        .then(() => {
          this.$data.disableButton = true;
          this.$data.isButtonLoading = false;
        })
        .catch(() => {
          this.$data.isButtonLoading = false;
        });
    }
  }
